import clsx from "clsx"
import { npPagePbClassName, npPagePxClassName } from "src/components/np-design/components/constants"
import { mapLineBreaksToHtmlBreaks } from "src/utilities/html"

export type HeroTextProps = {
  heading: string
  description: string | string[] | undefined
}

export const HeroText = ({ heading, description }: HeroTextProps) => {
  description = [description].flat().join("<br />")

  return (
    <section aria-label={heading} className={clsx(npPagePxClassName, npPagePbClassName)}>
      <div className={clsx("RichText flex flex-col items-center gap-4 text-center")}>
        <h1 className="mb-0 max-w-3xl">{heading}</h1>

        {description && (
          <div
            className="max-w-prose text-lg text-pretty"
            dangerouslySetInnerHTML={{ __html: mapLineBreaksToHtmlBreaks(description) }}
          />
        )}
      </div>
    </section>
  )
}
